module.exports = __webpack_public_path__ + "static/2boxesthx-26387c031282f1e39c8923a2973ffb75.png";